/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */
import React from 'react';
import Paper from '@material-ui/core/Paper';
import '../../css/table/Table.css'

/**
 * Table Component
 */
export default function Table(props) {
    return (
        <Paper className='table-paper'>
            {props.tableToolBar()}
        </Paper>
    );
}